module.exports = __webpack_public_path__ + "img/UTREDF-5.07941452.jpg";